export class Login {
  constructor(public userName: string, public password: string, public roleType: string, public rememberMe: boolean) { }
}
